<template>
<div>
		<v-row>
				<v-col cols-12 class="text-center text-uppercase">
					<h1>Dados do Evento</h1>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols-12 class="text-center">
					<v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                <span class="font-weight-medium">Código: </span> {{evento.id}} 
                                <br />
                                <span class="font-weight-medium">Data: </span> {{evento.data_evento}}
                                <br />
                                <span class="font-weight-medium">Local: </span> {{evento.descricao_local}}
                                <br />
                                <span class="font-weight-medium">Título: </span> {{evento.titulo}}
                                <br />
                                <span class="font-weight-medium">Horário: </span> {{evento.inicio}}
                                <br />
                                <span class="font-weight-medium">Grau: </span> {{evento.grau}}º
                                <br />
                                <span class="font-weight-medium">Observação: </span> {{evento.observacao}}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
				</v-col>
                <v-col cols-12 class="text-center">
					<v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                <br />
                                <span class="font-weight-medium">Confirmados: </span> {{status.confirmados}} 
                                <br />
                                <span class="font-weight-medium">Recusados: </span> {{status.recusados}}
                                <br />
                                <span class="font-weight-medium">Pendentes: </span> {{status.pendentes}}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
				</v-col>
			</v-row>

		<v-row>
			<v-col col-12 class="text-center">
				<h2>Confirmações</h2>
			</v-col>
		</v-row>
        <v-simple-table height="300" fixed-header="true">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-center">Nome</th>
                        <th class="text-center">Grau</th>
                        <th class="text-center">Clã</th>
                        <th class="text-center">Confirmação</th>
                        <th class="text-center">Data</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="ev in participantes" :key="ev.id">
                        <td class="text-center">{{ev.nome}}</td>
                        <td class="text-center">{{ev.grau}}º</td>
                        <td class="text-center">{{ev.cla}}</td>
                        <td class="text-center">{{ev.confirmacao}}</td>
                        <td class="text-center">{{ev.data_confirmacao}}</td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
	</div>
</template>

<script>
	export default{
		name: "ListaParticipantes",
		props: ['evento', 'participantes'],
		data(){
			return{
				status: {
					pendentes: 0,
					confirmados: 0,
					recusados: 0
				}
			}
		},
		methods:{
			contaParticipacoes(){
				this.participantes.forEach((v) =>{
					switch(v.status){
						case '0':
						this.status.pendentes++
						break

						case '1':
						this.status.confirmados++
						break

						case '2':
						this.status.recusados++
						break
					}
				})
			}
		},
		created(){
            this.contaParticipacoes()
            
		}
	}
</script>
<style scoped>
	div.tabelas{
		width: 100%;
		background-color: white;
		padding: 10px;
		border-radius: 6px;
		display: flex;
		flex-direction: column;
		overflow: auto;
		max-height: 580px;
	}

	#tabela{
		display: block;
		width: 90%;
		text-align: center;
		border-collapse: collapse;
		border: 1px solid black;
		padding: 8px;
		margin: 0 auto;
	}

	#tabela tr{
		width: 100%;
		border: 1px solid black;
	}

	#tabela tr td{
		width: 50%;
		text-align: left;
		padding-left: 10px;
	}


	table.confirmacao{
		width: 100%;
		text-align: center;
		border-collapse: collapse;
		border: 1px solid black;
		padding: 8px;
		margin: 0 auto;
	}

	table.confirmacao tr{
		width: 100%;
		border-collapse: collapse;
		border: 1px solid black;
	}

	table.confirmacao tr th{
		font-size: 14px;
		border-collapse: collapse;
		border: 1px solid black;
	}
	table.confirmacao tr td{
		width: 20%;
		font-size: 12px;
		border-collapse: collapse;
		border: 1px solid black;
	}

	#tabela tr{
		margin: 10px;
	}

	#tabela tr td tr span{
		padding: 10px;
	}

	#tabela tr td.coluna{
		text-align: center;
	}

	.ultimaLinha{
		text-align: left;
	}

	.linhaEmBranco{
		color: white;
	}

	.dadosRelatorio{
		font-weight: 300;
		font-size: 8px;
	}

	table.confirmacao .titulo, table.dados .titulo{
		font-size: 18px;
	}
</style>